import AddIcon from "@mui/icons-material/Add";
import { Button, FormControl, Input, Typography } from "@mui/joy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { Util } from "../Helpers/Util";
import UsersDialog from "../Dialogs/UsersDialog";
import PortalTableLayout from "../components/PortalTableLayout";

interface User {
	users_id: string;
	email_address: string;
	full_name: string;
	title: string;
	buildings: string;
	is_packing_lists?: boolean;
}

export default function UsersListing() {
	const [users, setUsers] = React.useState<Array<User>>();
	const [search, setSearch] = React.useState("");
	const [user, setUser] = React.useState("");
	const [dialog, setDialog] = React.useState(false);
	React.useEffect(() => getData(), []);

	const getData = () => {
		setDialog(false);
		fetch("User/GetUserSetup", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => setUsers(x));
	};

	const s = search.toLowerCase();
	const rows = users?.filter((x) => Util.isNullOrEmpty(search) || x.full_name?.toLowerCase().includes(s) || x.email_address?.toLowerCase().includes(s) || x.buildings?.toLowerCase().includes(s));
	return (
		<>
			{dialog && <UsersDialog usersId={user} close={getData} />}
			<PortalTableLayout
				toolbar={
					<div>
						<Typography sx={{ display: "inline-block" }} level="title-lg">
							Users Setup
						</Typography>
						<div style={{ float: "right", display: "flex" }}>
							<FormControl sx={{ marginRight: 1 }}>
								<Input
									name="Search"
									placeholder="Global Search"
									onChange={(event) => {
										setSearch(event.target.value);
									}}
									value={search}
								/>
							</FormControl>
							<Button
								startDecorator={<AddIcon />}
								onClick={() => {
									setUser("");
									setDialog(true);
								}}>
								New User
							</Button>
						</div>
					</div>
				}>
				<Table stickyHeader size="small">
					<TableHead>
						<TableRow>
							<TableCell>Name</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Title</TableCell>
							<TableCell>Packing lists</TableCell>
							<TableCell>Buildings</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows?.map((x) => (
							<TableRow
								key={x.users_id}
								hover
								sx={{ cursor: "pointer" }}
								onClick={() => {
									setUser(x.users_id);
									setDialog(true);
								}}>
								<TableCell>{x.full_name}</TableCell>
								<TableCell>{x.email_address}</TableCell>
								<TableCell>{x.title}</TableCell>
								<TableCell>{x.is_packing_lists ? "Yes" : ""}</TableCell>
								<TableCell>{x.buildings}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</PortalTableLayout>
		</>
	);
}
